<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 33.3334H8.66671C6.79987 33.3334 5.86644 33.3334 5.15341 32.97C4.5262 32.6505 4.01626 32.1405 3.69669 31.5133C3.33337 30.8003 3.33337 29.8669 3.33337 28V12C3.33337 10.1332 3.33337 9.19976 3.69669 8.48672C4.01626 7.85951 4.5262 7.34958 5.15341 7.03C5.86644 6.66669 6.79987 6.66669 8.66671 6.66669H9.33337C13.0671 6.66669 14.9339 6.66669 16.36 7.39331C17.6144 8.03247 18.6343 9.05234 19.2734 10.3068C20 11.7328 20 13.5997 20 17.3334M20 33.3334V17.3334M20 33.3334H31.3334C33.2002 33.3334 34.1336 33.3334 34.8467 32.97C35.4739 32.6505 35.9838 32.1405 36.3034 31.5133C36.6667 30.8003 36.6667 29.8669 36.6667 28V12C36.6667 10.1332 36.6667 9.19976 36.3034 8.48672C35.9838 7.85951 35.4739 7.34958 34.8467 7.03C34.1336 6.66669 33.2002 6.66669 31.3334 6.66669H30.6667C26.933 6.66669 25.0662 6.66669 23.6401 7.39331C22.3857 8.03247 21.3658 9.05234 20.7267 10.3068C20 11.7328 20 13.5997 20 17.3334"
      stroke="#5258FB"
      stroke-width="3.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
